export default __webpack_public_path__ + "static/media/rightArrowBlack.8ac6801c.svg";